import styled from "styled-components";
import { TableRow } from "@material-ui/core";
import { green, grey } from "@material-ui/core/colors";
import { TableRowProps } from "@material-ui/core/TableRow";
import React from "react";

interface IProps extends TableRowProps {
  isActive: boolean;
}

export const STTableRow = styled(({ isActive, children, ...rest }: IProps) => (
  <TableRow {...rest}>{children}</TableRow>
))`
  && {
    border-left: 10px solid
      ${(props: IProps) => (props.isActive ? green[300] : grey[300])};
  }
`;
